import { render, staticRenderFns } from "./WriteGoods.vue?vue&type=template&id=3f8b3e5c&"
import script from "./WriteGoods.vue?vue&type=script&lang=js&"
export * from "./WriteGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports